<template>
  <v-dialog-old id="vueTableSettings" ref="dialog">
      <div>
        <form>
          <fieldset style="padding: 10px">
            <legend>Скрыть/показать столбцы</legend>
            <label v-for="column in fields">
              <input type="checkbox" :name="column.name" value="1" v-model="checked[column.name]"/>
              <span><b v-html="column.title"></b>
                  <span v-if="column.tooltip">({{column.tooltip}})</span>
              </span>
            </label>
          </fieldset>
        </form>
      </div>

      <template v-slot:footer>
        <button class="green" width="100" @click="save">Ок</button>
      </template>
  </v-dialog-old>
</template>

<script>
import Vue from 'vue';
export default {
  name: "DoctuTableSettingsDialog",
  model: {
    prop: 'hidden',
    event: 'input'
  },
  props: {
    hidden: {
      required: true,
    },
  },
  data: function () {
    return {
      checked: {},
    };
  },
  created: function () {
  },
  computed: {
    fields: function () {
      return this.$parent.fields;
    }
  },
  methods: {
    init: function () {
      this.fields.forEach((column) => {
        if (this.hidden.indexOf(column.name) < 0) {
            Vue.set(this.checked, column.name, true)
        }
      });
    },
    show() {
      this.init()
      this.$refs.dialog.show()
    },
    hide() {
      this.$refs.dialog.hide()
    },
    save() {
      let hidden = this.fields.map((column) => {
        if (!this.checked[column.name]) {
          return {
              name: column.name,
              sort: column.sort
          }
        }
        return false
      })
      let result = hidden.filter((e) => {
        return e
      })

      this.$parent.setHidden(result)
      this.$refs.dialog.hide()
    }
  },
}
</script>
